export class RoleControls {
  roles: string[] = [];
  controls: Array<any>=[];
}
